import { createAction } from 'redux-api-middleware';
import * as types from '../types/talentsTypes';
import { API_URL } from '../../config';
import { TALENTS_MODE } from '../../config/consts';
import { getApiToken, buildFiltersQuery } from '../utils';

export const fetchTalents = (filters) =>
  createAction({
    endpoint: (store) => {
      const { page } = store.talents;
      const { size } = store.talents;
      const filtersQuery = buildFiltersQuery(filters, store.talentFilters);
      return `${API_URL}/api/v1/talentpool/talents?${
        filtersQuery.length ? filtersQuery : ''
      }${page > 1 ? `cursor=${(page - 1) * size}&` : ''}limit=${size}`;
    },
    method: 'GET',
    headers: (store) => ({
      'content-type': 'application/json',
      accept: 'application/json',
      authorization: `Basic ${getApiToken(store.firebase)}`,
    }),
    types: [
      types.FETCH_TALENTS,
      types.FETCH_TALENTS_SUCCESS,
      types.FETCH_TALENTS_FAILURE,
    ],
  });

export const searchTalents = () =>
  createAction({
    endpoint: (store) => {
      let query = '';
      const searchMode = store.talentFilters.search.mode;
      if (searchMode === 'id') {
        query = `talent_id=${store.talentFilters.search.id}`;
      } else {
        if (store.talentFilters.search.firstName) {
          query += `given_name=${store.talentFilters.search.firstName}&`;
        }
        if (store.talentFilters.search.lastName) {
          query += `family_name=${store.talentFilters.search.lastName}&`;
        }
        if (store.talentFilters.search.email) {
          query += `email=${store.talentFilters.search.email}`;
        }
      }
      return `${API_URL}/api/v1/talentpool/talents/search?${query}`;
    },
    method: 'GET',
    headers: (store) => ({
      'content-type': 'application/json',
      accept: 'application/json',
      authorization: `Basic ${getApiToken(store.firebase)}`,
    }),
    types: [
      types.SEARCH_TALENTS,
      types.SEARCH_TALENTS_SUCCESS,
      types.SEARCH_TALENTS_FAILURE,
    ],
  });

export const fetchData = (filters) => (dispatch, getState) => {
  const mode = getState().talentFilters.talentsMode;

  if (mode === TALENTS_MODE.search) {
    const searchStore = getState().talentFilters.search;
    if (searchStore.mode === 'id' && !searchStore.id) {
      dispatch(fetchTalents(filters));
    } else if (
      searchStore.mode === 'info' &&
      !searchStore.firstName &&
      !searchStore.lastName &&
      !searchStore.email
    ) {
      dispatch(fetchTalents(filters));
    } else {
      dispatch(searchTalents());
    }
  } else {
    dispatch(fetchTalents(filters));
  }
};

export const setTalentsPage = (page) => ({
  type: types.SET_TALENTS_PAGE,
  payload: page,
});

export const resetTalentsState = () => ({
  type: types.RESET_TALENTS_STATE,
});
